var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobeWhy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6754_216224",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 58,
    height: 59
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.00134277H58.0006V58.002H0V0.00134277Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6754_216224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4513 34.4354C28.4513 42.0401 26.0242 48.2051 23.0303 48.2051C20.0365 48.2051 17.6094 42.0401 17.6094 34.4354C17.6094 26.8305 20.0365 20.6657 23.0303 20.6657C26.0242 20.6657 28.4513 26.8305 28.4513 34.4354Z",
    stroke: "black",
    strokeWidth: 2.26565,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25781 34.4375H36.7971",
    stroke: "black",
    strokeWidth: 2.26565,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0274 48.2051C30.6322 48.2051 36.7971 42.0402 36.7971 34.4355H9.25781C9.25781 42.0402 15.4226 48.2051 23.0274 48.2051Z",
    stroke: "black",
    strokeWidth: 2.26565,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0274 20.6678C15.4226 20.6678 9.25781 26.8326 9.25781 34.4375H36.7971C36.7971 26.8326 30.6322 20.6678 23.0274 20.6678Z",
    stroke: "black",
    strokeWidth: 2.26565,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.529 15.42C47.506 17.2212 45.2166 17.8533 43.4143 16.8304C41.6142 15.8074 40.9821 13.518 42.005 11.7157C43.028 9.91447 45.3174 9.28349 47.1198 10.3064C48.9209 11.3295 49.5519 13.6188 48.529 15.42ZM53.8918 13.5316C53.885 11.787 55.1662 10.3393 56.8428 10.0901C56.5754 9.21212 56.205 8.35231 55.7224 7.52421C55.241 6.69838 54.6757 5.95072 54.0424 5.28689C53.0014 6.62362 51.1084 7.0269 49.5938 6.16143C48.0815 5.29719 47.4675 3.46304 48.0895 1.88841C47.1979 1.67997 46.1886 1.57349 45.2665 1.57122C44.3455 1.57349 43.3361 1.67997 42.4446 1.88841C43.0665 3.46304 42.4525 5.29719 40.9402 6.16143C39.4245 7.0269 37.5338 6.62362 36.4916 5.28689C35.8595 5.95072 35.2942 6.69838 34.8127 7.52421C34.3302 8.35231 33.9586 9.21212 33.6924 10.0901C35.3678 10.3393 36.6491 11.787 36.6411 13.5316C36.6343 15.2727 35.3395 16.7104 33.6641 16.9459C34.1863 18.7244 35.1175 20.3852 36.4202 21.7717C37.4738 20.4452 39.3678 20.0578 40.8756 20.938C42.3823 21.8159 42.9781 23.6545 42.3426 25.2246C43.2783 25.4546 44.3228 25.5657 45.2665 25.5644C46.2112 25.5657 47.2557 25.4546 48.1914 25.2246C47.5559 23.6545 48.1529 21.8159 49.6595 20.938C51.1662 20.0578 53.0603 20.4452 54.1138 21.7717C55.4154 20.3852 56.3477 18.7244 56.87 16.9459C55.1945 16.7104 53.8997 15.2727 53.8918 13.5316Z",
    stroke: "black",
    strokeWidth: 2.26565,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0739 12.4457H23.2231C11.0229 12.4457 1.13281 22.3359 1.13281 34.536C1.13281 38.4556 2.16368 42.1338 3.96748 45.3164",
    stroke: "black",
    strokeWidth: 2.26565,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6562 52.6046C14.1757 55.0183 18.435 56.4316 23.0251 56.4316H23.1699C35.3699 56.4316 45.2601 46.5416 45.2601 34.3414V30.7597",
    stroke: "black",
    strokeWidth: 2.26565,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7339 9.08192L28.0995 12.4474L24.6953 15.8516",
    stroke: "black",
    strokeWidth: 2.26565,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8984 34.1253L45.2638 30.7598L48.668 34.1641",
    stroke: "black",
    strokeWidth: 2.26565,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeWhy);
export default __webpack_public_path__ + "static/media/globe_why.993cf03aafe6e4bf792b23a58698c8b7.svg";
export { ForwardRef as ReactComponent };